var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#66BF50",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2927 14.8534C27.6833 15.244 27.6833 15.8771 27.2927 16.2677L18.4141 25.1463C18.0235 25.5369 17.3904 25.5369 16.9998 25.1463L12.707 20.8534C12.3164 20.4629 12.3164 19.8298 12.707 19.4392C13.0975 19.0487 13.7306 19.0487 14.1212 19.4392L17.707 23.025L25.8785 14.8534C26.2691 14.4629 26.9022 14.4629 27.2927 14.8534Z",
    fill: "#66BF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.c5e41e1a8f3c83c39eed85b0242e2751.svg";
export { ForwardRef as ReactComponent };